export default "__VITE_ASSET__CCTXfXCg__"